define('shared/remote/payment/previous',[
    'shared/lib/RSVP', 
    'shared/remote/ajax',
],
function (
    RSVP, 
    ajax
) {
    'use strict';

    return function newHouse() {
        return ajax({
            url: '/1/api/commerce-gateway/member/payment-token-account',
            type: 'GET',
            dataType: 'json'
        })
        .then(function(json){
            return json;
        });
    };
});
